import { Breadcrumbs } from '../models/breadcrumbs.models';

import { ApplicationSections } from '@core/domain/models/application-section.model';
import { HomeConfig } from '@core/domain/state/core.state';
import { ProductPublicModels } from '@features/products/product';
import { MenuCategory } from '@shared/header/models/category.model';

export function isHomeCategory(sectionPathEn: string): boolean {
    return sectionPathEn === ApplicationSections.WOMEN || sectionPathEn === ApplicationSections.MEN;
}

export function getHomeLocationPath(sectionPathEn: string, homeConfig: HomeConfig[]): string {
    return homeConfig.find((home) => home.section.toUpperCase() === sectionPathEn)?.locationPath;
}

export function findCategoryById(categories: MenuCategory[], categoryId: string): MenuCategory | undefined {
    return categories.find((cat) => cat.id === categoryId);
}

export function buildBreadcrumbsRecursively(
    categoryId: string,
    categoriesNavigation: MenuCategory[],
    homeConfig: HomeConfig[],
    breadcrumbs: Breadcrumbs = [],
): Breadcrumbs {
    const originalCategory = findCategoryById(categoriesNavigation, categoryId);
    let category = originalCategory;

    // Si la categoría tiene un redirectToCategoryId, buscamos la categoría a la que redirige y la usamos para construir el breadcrumb, pero comprobamos el parent de la categoría original para evitar un bucle infinito.
    if (originalCategory?.redirectToCategoryId) {
        category = findCategoryById(categoriesNavigation, category.redirectToCategoryId);
    }

    if (category) {
        // biome-ignore lint/nursery/useTopLevelRegex: <explanation>
        const sectionPath = category.sectionPathEn.toUpperCase().replace(/\/+$/, ''); // Eliminamos la última barra si la tiene (Hay categorías que la implementan en su locationPath)
        // eslint-disable-next-line max-len
        const locationPath = isHomeCategory(sectionPath) ? getHomeLocationPath(sectionPath, homeConfig) : category.locationPath;
        const breadcrumbMatch = breadcrumbs.some((breadcrumb) => breadcrumb.url === locationPath);

        if (!breadcrumbMatch) {
            breadcrumbs.unshift({
                label: originalCategory.seoCategory.mainHeader ?? originalCategory.name,
                url: locationPath,
            });
        }

        if (originalCategory.parentId) {
            return buildBreadcrumbsRecursively(originalCategory.parentId, categoriesNavigation, homeConfig, breadcrumbs);
        }
    }

    return breadcrumbs;
}

export function buildBreadcrumbsUseCase(
    categoryId: string,
    product: ProductPublicModels.PublicProduct | null,
    categoriesNavigation: MenuCategory[],
    homeConfig: HomeConfig[],
): Breadcrumbs {
    const breadcrumbs: Breadcrumbs = [];

    if (product) {
        breadcrumbs.unshift({
            label: product.name,
        });
    }

    const categoryBreadcrumbs = buildBreadcrumbsRecursively(categoryId, categoriesNavigation, homeConfig);

    return categoryBreadcrumbs.concat(breadcrumbs);
}
